module.exports = __webpack_public_path__ + "img/f2.b3f861c9.jpg";